import React from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Briefcase,
  FileText,
  Image as ImageIcon,
  LayoutGrid,
  LogOut,
  Settings,
  Users,
  UsersRound,
} from "lucide-react";
import { logout } from "@/lib/authApi";
import { getStoredUser } from "@/lib/apiClient";

const sidebarItems = [
  { icon: LayoutGrid, label: "Dashboard", to: "/cms" },
  { icon: FileText, label: "Konten" },
  { icon: Briefcase, label: "Portfolio", to: "/cms/portfolio" },
  { icon: UsersRound, label: "Tim", to: "/cms/team" },
  { icon: ImageIcon, label: "Media" },
  { icon: Users, label: "Pengguna" },
  { icon: Settings, label: "Pengaturan" },
];

const CMSLayout = ({ active, breadcrumb, title, headerActions, children }) => {
  const navigate = useNavigate();
  const user = getStoredUser();

  const handleLogout = async () => {
    await logout();
    navigate("/cms/login", { replace: true });
  };

  return (
    <div className="min-h-screen bg-slate-950 text-slate-100">
      <div className="flex min-h-screen flex-col lg:flex-row">
        <aside className="w-full border-b border-slate-800 bg-slate-900/80 p-6 lg:w-72 lg:border-b-0 lg:border-r">
          <div className="flex items-center gap-3">
            <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-gradient-to-br from-cyan-400 to-blue-600 font-semibold text-white">
              R
            </div>
            <div>
              <p className="text-lg font-semibold">Ransel CMS</p>
              <p className="text-sm text-slate-400">Content management</p>
            </div>
          </div>

          <nav className="mt-8 space-y-2">
            {sidebarItems.map((item) => {
              const Icon = item.icon;
              const isActive = item.label === active;
              const className = `flex w-full items-center gap-3 rounded-2xl px-4 py-3 text-left text-sm font-medium transition ${
                isActive
                  ? "bg-cyan-500/15 text-cyan-300"
                  : "text-slate-300 hover:bg-slate-800 hover:text-white"
              }`;

              if (item.to) {
                return (
                  <Link key={item.label} to={item.to} className={className}>
                    <Icon size={18} />
                    {item.label}
                  </Link>
                );
              }

              return (
                <button key={item.label} type="button" className={className}>
                  <Icon size={18} />
                  {item.label}
                </button>
              );
            })}
          </nav>

          <div className="mt-8 rounded-3xl border border-slate-800 bg-slate-950/70 p-4">
            <p className="text-sm font-semibold text-white">
              {user?.name || "Admin"}
            </p>
            <p className="mt-1 truncate text-sm text-slate-400">{user?.email}</p>
            <button
              type="button"
              onClick={handleLogout}
              className="mt-4 flex items-center gap-2 rounded-full border border-slate-700 px-4 py-2 text-sm font-semibold text-slate-200 transition hover:bg-slate-800"
            >
              <LogOut size={16} /> Keluar
            </button>
          </div>
        </aside>

        <main className="flex-1">
          <header className="border-b border-slate-800 bg-slate-900/70 px-4 py-4 sm:px-6 lg:px-8">
            <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
              <div>
                <p className="text-sm text-cyan-300">{breadcrumb}</p>
                <h1 className="text-2xl font-semibold text-white">{title}</h1>
              </div>

              <div className="flex flex-wrap items-center gap-3">
                {headerActions}
                <Link
                  to="/"
                  className="rounded-full border border-slate-700 px-4 py-2 text-sm text-slate-200 transition hover:bg-slate-800"
                >
                  Lihat Website
                </Link>
              </div>
            </div>
          </header>

          <div className="space-y-6 p-4 sm:p-6 lg:p-8">{children}</div>
        </main>
      </div>
    </div>
  );
};

export default CMSLayout;
